import { render } from "./Guide_GreenDrinks.vue?vue&type=template&id=0d9042ea"
import script from "./Guide_GreenDrinks.vue?vue&type=script&lang=js"
export * from "./Guide_GreenDrinks.vue?vue&type=script&lang=js"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__